import { useEffect } from 'react';

import { CAPTCHA_PROVIDER, CAPTCHA_PROVIDER_CONFIG } from '@shared/components/captcha/constants';

import { useSystemSettingsValue } from '../useSystemSettingsValue';

const KNOWN_CAPTCHA_PROVIDERS: string[] = Object.values(CAPTCHA_PROVIDER);

const useCaptchaProvider = (isActive = true) => {
  const { getValue, isFetching, error } = useSystemSettingsValue([CAPTCHA_PROVIDER_CONFIG], !isActive);
  const captchaProvider = getValue(CAPTCHA_PROVIDER_CONFIG);

  useEffect(() => {
    if (isActive && !isFetching && (error || !captchaProvider || !KNOWN_CAPTCHA_PROVIDERS.includes(captchaProvider))) {
      // Silently fallback to Turnstile as the default provider
      console.warn('Failed to resolve captchaProvider: ', error ?? captchaProvider);
    }
  }, [isActive, isFetching, error, captchaProvider]);

  return { captchaProvider, isLoadingCaptchaProvider: isFetching };
};

export default useCaptchaProvider;
